import React, { useState } from "react"
import { PlayIcon } from '@heroicons/react/24/outline'

function getYouTubeVideoId(videoUrl) {
  const videoUrlRegEx = /(?:youtube(?:-nocookie)?\.com\/(?:[^\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
  return videoUrl?.length && videoUrl?.includes('youtu') && videoUrl?.match(videoUrlRegEx)?.length > 1
    ? videoUrl.match(videoUrlRegEx)[1]
    : null
}


function VideoImage({ youtubeVideoId, poster }) {
  return <>{youtubeVideoId ? <img
    src={poster || `https://img.youtube.com/vi/${youtubeVideoId}/hqdefault.jpg`}
    alt="Video thumbnail"
    className="absolute inset-0 w-full h-full object-cover"
    objectFit='cover'
    layout="fill"
    sizes="100vw" /> :
    <div className="absolute inset-0 w-full h-full bg-radial-gradient bg-gray-400 bg-blend-multiply"></div>
  }</>
}

const BannerVideo = ({ video, poster, videoEmbed, videoTitle, videoOptions }) => {
  const videoSource = videoOptions?.videoSource || "mediaLibrary"
  const youtubeVideoId = videoSource === "youtube" && videoEmbed ? getYouTubeVideoId(videoEmbed) : undefined
  let [isPlaying, setIsPlaying] = useState(false)
  return (
    <>
      {youtubeVideoId ?
        !isPlaying ? (
          <button
            onClick={() => {
              setIsPlaying(true)
            }}
            className="absolute inset-0 w-full h-full flex items-center justify-center group transition hover:scale-[101%]"
          >
            <VideoImage youtubeVideoId={youtubeVideoId} poster={poster} />
            <div className="absolute inset-0 w-full h-full mix-blend-multiply bg-gray-900/25"></div>
            <div className="relative">
              <div className="absolute inset-0 w-full h-full transition bg-gray-800 mix-blend-multiply group-hover:bg-gray-900"></div>
              <div className="absolute inset-0 w-full h-full transition bg-gray-900/30 group-hover:bg-gray-900/60"></div>

              <button
                onClick={() => {
                  setIsPlaying(true)
                }}
                className="flex link-stretched items-center text-white p-6 relative"
              >
                {videoTitle || "Play Video"} <PlayIcon className="text-5xl flex-shrink-0 w-8 h-8 ml-2" aria-label="Play Video" />
              </button>
            </div>
          </button>) :
          <iframe
            src={`https://www.youtube-nocookie.com/embed/${youtubeVideoId}?autoplay=1`}
            className="absolute inset-0 aspect-video w-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title={"YouTube video player"}
          />
        : video?.mediaItemUrl ? (
          <div className="video inset-0 absolute">
            <video
              controls={false}
              autoPlay
              muted
              loop
              aria-label={video.title}
              poster={poster}
              playsInline
              className="w-full h-full object-cover"
              onLoad="play()"
              preload="auto"
              webkit-playsInline
            >
              <source
                src={video.mediaItemUrl}
                type={`video/${video.mediaItemUrl.split('.').pop()}`}
              />
            </video>
          </div>
        )
          : videoEmbed ? <iframe src={videoEmbed} title={video.title} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
            : null
      }
    </>
  )
}
export default BannerVideo
